import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Routes from '../../routes';
import Loading from '../../components/loading';
import { APP_VERSION } from '../../constants/api';
import { clearCacheData, getVersion } from '../../util/tools';

function Layouts() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAppVersion();
  }, []);

  const checkAppVersion = async () => {
    try {
      let url = process.env.REACT_APP_API_URL + APP_VERSION;
      let response = await axios.post(url, { vAppType: 'Forms' });
      response = response.data;
      if (response.settings.success === 1 && response.data.length !== 0) {
        const appVersion = getVersion();
        const serverVersion = response.data[0].vAppVersion;
        console.log('Server Version', serverVersion);
        console.log('App Version', appVersion);
        if (appVersion !== serverVersion) {
          clearCacheData();
        }
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      {loading ? <Loading loadingPage={loading} /> : <Routes />}
    </React.Fragment>
  );
}

export default Layouts;
